<template>
  <div>
    <vue-element-loading
      :active="appLoading"
      spinner="bar-fade-scale"
      color="#1976d2"
      size="128"
      is-full-screen
    />
    <v-snackbar v-model="showSnackBar" color="#e7ab5f" right :timeout="timeout">
      <v-layout wrap justify-center>
        <v-flex text-left class="align-self-center">{{ msg }}</v-flex>
        <v-flex text-right>
          <v-btn small :ripple="false" text @click="showSnackBar = false">
            <v-icon style="color: white">mdi-close</v-icon>
          </v-btn>
        </v-flex>
      </v-layout>
    </v-snackbar>
    <v-dialog v-model="editdialog" max-width="600px">
      <v-card>
        <v-form v-model="addslider">
          <v-card-title>
            <span class="headline">Edit Client</span>
          </v-card-title>
          <v-card-text>
            <!-- <v-layout>
                                  <v-flex xs12 md12 lg12>
                                    <v-text-field
                                      outlined
                                      row="4"
                                      v-model="editingitem.text"
                                      label="Values"
                                      :rules="[rules.required]"
                                      required
                                    ></v-text-field>
                                  </v-flex>
                                </v-layout> -->
                                 <v-layout>
                                  <v-flex xs12 md12 lg12>
                                    <v-text-field
                                      outlined
                                      row="4"
                                      v-model="editingitem.order"
                                      label="Order"
                                      :rules="number"
                                      required
                                    ></v-text-field>
                                  </v-flex>
                                </v-layout>
            <v-layout wrap>
              <v-flex xs12 md12 lg12>
                <v-img
                  v-if="editingitem.image && !imagePreview"
                  :src="baseURL + editingitem.image"
                  width="400px"
                  height="200px"
                  class="align-center"
                  contain
                /><br />
                <v-img
                  v-if="imagePreview"
                  :src="imagePreview"
                  width="400px"
                  height="200px"
                  class="align-center"
                  contain
                /><br />
                <v-btn outlined @click="$refs.showImage.click()"
                  >Upload Image
                  <v-item-group>
                    <input
                      v-show="false"
                      label="Upload Image"
                      ref="showImage"
                      id="file"
                      type="file"
                      style="display: none"
                      @change="showImage"
                    />
                    <!-- </v-file-input> -->
                  </v-item-group>
                </v-btn>
              </v-flex>
            </v-layout>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="blue darken-1" text @click="editdialog = false">
              Close
            </v-btn>
            <v-btn
              color="blue darken-1"
              text
              :disabled="!addslider"
              @click="edit(editingitem._id)"
            >
              Save
            </v-btn>
          </v-card-actions>
        </v-form>
      </v-card>
    </v-dialog>
    <v-layout v-if="ServerError" wrap justify-center>
      <v-flex px-5 pt-5 xs12 sm12 md12 lg12 xl12 text-center>
        <ServerError />
      </v-flex>
    </v-layout>
    <v-layout v-else wrap justify-center>
      <v-flex px-5 pt-5 xs12 sm12 md12 lg12 xl12 text-center>
        <v-card>
          <v-card-title class="elevation-1">
            Clients
            <v-spacer></v-spacer>
            <v-dialog
              :retain-focus="false"
              v-model="dialog"
              persistent
              max-width="600px"
              :key="dialog"
            >
              <template v-slot:activator="{ on, attrs }">
                <v-btn outlined color="red" v-bind="attrs" v-on="on">
                  Add
                </v-btn>
              </template>
              <v-card>
                <v-form v-model="addslider">
                  <v-card-title>
                    <span class="headline">Add Clients</span>
                  </v-card-title>
                  <v-card-text>
                    <!-- <v-layout>
                      <v-flex xs12 md12 lg12>
                        <v-text-field
                          rows="4"
                          outlined
                          v-model="sliderText"
                          label="Slider Text"
                          :rules="[rules.required]"
                          required
                        ></v-text-field>
                      </v-flex>
                    </v-layout> -->
                    <v-layout>
                      <v-flex xs12 md12 lg12>
                        <v-text-field
                          rows="4"
                          outlined
                          v-model="order"
                          label="Order"
                          :rules="number"
                          required
                        ></v-text-field>
                      </v-flex>
                    </v-layout>
                    <v-layout wrap>
                      <v-flex xs12 md12 lg12>
                        <v-img
                          v-if="imagePreview"
                          :src="imagePreview"
                          width="400px"
                          height="200px"
                          class="align-center"
                          contain
                        /><br />
                        <v-btn outlined @click="$refs.showImage.click()"
                          >Upload Image
                          <v-item-group>
                            <input
                              v-show="false"
                              label="Upload Image"
                              ref="showImage"
                              id="file"
                              type="file"
                              style="display: none"
                              @change="showImage"
                            />
                            <!-- </v-file-input> -->
                          </v-item-group>
                        </v-btn>
                      </v-flex>
                    </v-layout>
                  </v-card-text>
                  <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn color="blue darken-1" text @click="dialogclose()">
                      Close
                    </v-btn>
                    <v-btn
                      color="blue darken-1"
                      text
                      :disabled="!addslider"
                      @click="add()"
                    >
                      Save
                    </v-btn>
                  </v-card-actions>
                </v-form>
              </v-card>
            </v-dialog>
          </v-card-title>
          <div v-if="storage">
            <v-container grid-list-md>
              <v-layout wrap pt-10 pb-10>
                <v-flex v-for="(item, i) in storage" :key="i" md3 pa-4>
                  <v-card style="line-height: 16px; cursor: pointer" tile flat>
                    <v-img
                      contain
                      :src="baseURL + item.image"
                      height="300px"
                      cover
                    >
                      <template v-slot:placeholder>
                        <v-row
                          class="fill-height ma-0"
                          align="center"
                          justify="center"
                        >
                          <v-progress-circular
                            indeterminate
                            color="#FF2323"
                          ></v-progress-circular>
                        </v-row>
                      </template>
                    </v-img>
                    <v-layout wrap justify-center px-2>
                      <br />
                      <v-flex px-4 xl12 md12 sm12 xs12 lg12 justify-center>
                        <span style="font-size: 16px; color: #000000">
                         Client {{ item.order }}
                        </span>
                      </v-flex>
                      <v-flex pt-5 pb-2 xl6 xs6 sm6 md6 lg6 px-5 justify-center>
                        <v-dialog v-model="item.delete" max-width="600px">
                          <template v-slot:activator="{ on, attrs }">
                            <v-btn
                              small
                              class="mr-2"
                              outlined
                              v-on="on"
                              v-bind="attrs"
                              color="red"
                            >
                              Delete
                            </v-btn>
                          </template>
                          <v-card>
                            <v-card-title
                              >Are you sure you want to delete this
                              client?</v-card-title
                            >
                            <v-card-actions>
                              <v-spacer></v-spacer>
                              <v-btn
                                color="blue darken-1"
                                text
                                @click="item.delete = false"
                                >Cancel</v-btn
                              >
                              <v-btn
                                color="blue darken-1"
                                text
                                @click="deleteItem(item)"
                                >OK</v-btn
                              >
                              <v-spacer></v-spacer>
                            </v-card-actions>
                          </v-card>
                        </v-dialog>
                      </v-flex>
                      <v-flex pt-5 px-4 xl6 sm6 xs6 lg6 md6 justify-center>
                        <v-btn small class="mr-2" outlined color="red" @click="editSlider(item)">
                          Edit
                        </v-btn>
                      </v-flex>
                      <br />
                    </v-layout>
                  </v-card>
                </v-flex>
              </v-layout>
            </v-container>
          </div>
          <div v-else>
            <v-layout justify-center fill-height wrap>
              <v-flex text-center xs12 lg12>
                <span
                  style="
                    font-size: 22px;
                    font-family: poppinssemibold;
                    letter-spacing: 1px;
                  "
                >
                  No slider Found...
                  <br />
                  Try adding Slider
                </span>
              </v-flex>
            </v-layout>
          </div>
        </v-card>
      </v-flex>
    </v-layout>
  </div>
</template>
<script>
import axios from "axios";
export default {
  data() {
    return {
      file: null,
      showPreview: false,
      imagePreview: null,
      text: null,
      editingitem: [],
      order:null,

      msg: null,
      showSnackBar: false,
      timeout: 5000,
      appLoading: false,

      pages: 0,
      widthOfCard: "250px",
      sliderText: null,
      heading: null,

      dialogDelete: false,
      search: "",
      ratings: [],
      dialog: false,
      editdialog: false,
      ServerError: false,
      storage: [],
      addslider: false,
      imgId: "",
      rules: {
        required: (value) => !!value || "Required.",
        min: (v) => v.length >= 8 || "Min 8 characters",
      },
      number:[(v)=>/^[0-9]+$/.test(v) || "Must be Number"]
    };
  },
  beforeMount() {
    this.getData();
  },
  methods: {
    getData() {
      this.appLoading = true;
      axios({
        url: "/clients/list",

        method: "GET",
        headers: {
          token: localStorage.getItem("token"),
        },
      })
        .then((response) => {
          if (response.data.status) {
            this.appLoading = false;
            this.storage = response.data.data;
          } else {
            this.storage = [];
          }
        })
        .catch((err) => {
          this.appLoading = false;
          this.ServerError = true;
          console.log(err);
        });
    },
    editSlider(item) {
      this.editingitem = item;
      this.editdialog = true;
    },
    dialogclose() {
      this.sliderText = null;
      this.dialog = false;
    },

    showImage(e) {
      // var files=e.target.files
      this.file = e.target.files[0];

      var reader = new FileReader();
      reader.onload = (e) => {
        this.imagePreview = e.target.result;
      };
      this.showPreview = true;

      //reader.readAsDataURL(files[0]);

      if (this.file) {
        if (/\.(jpe?g|png|gif)$/i.test(this.file.name)) {
          reader.readAsDataURL(this.file);
        }
      }
    },
    add() {
      let formData = new FormData();
      formData.append("image", this.file);
      formData.append("text", this.sliderText);
      formData.append("order", this.order);

      axios({
        method: "POST",
        url: "/clients/add",
        data: formData,
        headers: {
          "Content-Type": "multipart/form-data",
          token: localStorage.getItem("token"),
        },
      })
        .then((response) => {
          this.appLoading = false;
          if (response.data.status == true) {
            this.getData();
            this.showsnackbar = true;
            this.imagePreview=null;
            this.file=null;
            this.msg = "Uploaded Successfully";
            this.dialog = false;
          } else {
            this.msg = "Can't Update";
            this.showSnackBar = true;
          }
        })
        .catch((err) => {
          this.appLoading = false;
          this.ServerError = true;
          console.log(err);
        });
    },
    deleteItem(r) {
      // var data = {};
      // data["id"] = r._id;
      axios({
        url: "/clients/delete/" + r._id,
        method: "POST",
        // data: data,
        headers: {
          token: localStorage.getItem("token"),
        },
      })
        .then((response) => {
          this.delete = false;
          this.appLoading = false;
          if (response.data.status) {
            this.msg = "Delete Sucessfully";
            this.showsnackbar = true;
            this.getData();
          } else {
            this.msg = response.data.msg;
            this.showsnackbar = true;
          }
        })
        .catch((err) => {
          this.appLoading = false;
          this.ServerError = true;
          console.log(err);
        });
    },
    edit(id) {
      let formData = new FormData();
      formData.append("image", this.file);
      formData.append("text", this.editingitem.text);
      formData.append("order", this.editingitem.order);

      axios({
        method: "POST",
        url: "/clients/edit/" + id,
        data: formData,
        headers: {
          "Content-Type": "multipart/form-data",
          token: localStorage.getItem("token"),
        },
      })
        .then((response) => {
          this.appLoading = false;
          if (response.data.status == true) {
            this.getData();
            this.showsnackbar = true;
            this.msg = "Updated Successfully";
            this.editdialog = false;
          } else {
            this.msg = "Can't Update";
            this.showSnackBar = true;
          }
        })
        .catch((err) => {
          this.appLoading = false;
          this.ServerError = true;
          console.log(err);
        });
    },
  },
};
</script>